import React from "react";
import { component_tool, utils_tool } from '@/tool';
import QRCode from 'qrcode.react';
import ProgramCategorySelect from './programDetail/programCategorySelect'
let { WizModal, WizSurveyAudience, WizTypography, WizRow } = component_tool;
let { $$, checkStrLength } = utils_tool;
import { WizClassifySelect } from '@/containers/common';
import HighSet from "@/containers/common/highSet";

//配置项
let componentName = 'program'

const columns = [
  {
    name: "id",
    formItem: {
      type: "hidden"
    }
  },
  {
    title: "课程名称",
    name: "name",
    dataIndex: "name",

    searchItem: {},
    tableItem: {}
  },
  {
    title: "课程编码",
    name: "scoId",
    dataIndex: "scoId",

    searchItem: {},
    tableItem: {}
  },
  {
    title: "课程分类",
    name: "programCategoryNames",
    dataIndex: "programCategoryNames",
    tableItem: {}
  },
  {
    title: "课程分类",
    name: "programCategoryIds",
    dataIndex: "programCategoryIds",
    searchItem: {
      type: 'diy',
      diy: WizClassifySelect,
      returnKey: true,
      wizTreeSelectListProps: {
        itemProps: {
          icon: 'unordered-list',
          title: '课程分类',
          tips: '请勾选所属课程分类'
        },
        treeProps: { checkStrictly: true }
      },
      apiProps: { type: 1 },
      selectProps: {
        placeholder: '请选择课程分类'
      }
    }
  },
  {
    title: "归属部门",
    name: "programSource",
    dataIndex: "programSource",
    tableItem: {},
    searchItem: {
    },
  },
  {
    title: "状态",
    name: "status",
    dataIndex: "status",
    tableItem: {},
    dict: [
      { code: 0, codeName: "草稿" },
      { code: 1, codeName: "发布" },
      { code: 2, codeName: "关闭" }
    ],
    searchItem: {
      type: "select"
      // mode: 'multiple',
    },

  },
  {
    title: "截止时间",
    name: "endDate",
    dataIndex: "endDate",
    tableItem: {}
  },
];

this._downQrCode = () => {
  const canvasImg = document.getElementById('qrCode'); // 获取canvas类型的二维码
  const img = new Image();
  img.src = canvasImg.toDataURL('image/png'); // 将canvas对象转换为图片的data url
  let a_link = document.getElementById('down_link');
  a_link.href = img.src
  a_link.download = '课程二维码';
};

const templateConfig = (data) => {
  let {pathname} = data
  return {
    mainProps: {},
    content: {
      name: "WizTableList",
      params: {
        columns,
        searchBarProps: {
          cols: {
            xs: 12,
            md: 12,
            xl: 12
          },
          buttonSort: ['add', "delete", 'batchClose', "export"],
          buttons: [
            {
              key: "add",
              custom: true,
              params: { icon: "plus", children: "新增", type: "primary"},
              customOnClick: {
                key: "jumpPage",
                params: {
                  key: "push",
                  pathname: pathname+"/programDetailAdd"
                }
              }
            },
            {
              key: "delete",
              custom: true,
              needSelect: true,
              params: {icon: "delete", children: "删除", type: "danger"},
              customOnClick: {
                key: "action",
                params: {
                  apiKey: "delete",
                  apiParams: {}
                },
                formatParams: (rows, record, filters, callback) => {
                  if (!rows) return;
                  if ($$.isArray(rows) && !rows.length) return;
                  // const content = `删除后数据不可恢复，您确定要删除这${
                  //   $$.isArray(rows) ? rows.length : ""
                  // }条课程吗？`;
                  const content = '删除后数据不可恢复，您确定要删除选中的课程吗？'
                  let ids = [];
                  rows.forEach(e => {
                    if (e['rowKey']){
                      ids.push(e['rowKey']);
                    }
                  });
                  WizModal.confirm({
                    title: '注意', content,
                    onOk: () => {
                      callback && callback({
                        ids
                      })
                    },
                    onCancel() {
                    }
                  });
                  return null
                }
              },
              recordChangeParams: ({ record, rows }) => {
                let disabled = 0;
                if (rows && rows instanceof Array && rows.length>0){
                  rows.forEach(item => {
                    let {status} =item;
                    if (status !=null && status!=0){
                      disabled=1;
                    }
                  })
                }else {
                  disabled = 1;
                }
                return { disabled: disabled }
              }
            },
            {
              key: "batchClose",
              custom: true,
              needSelect: true,
              params: { icon: "into", children: "批量关闭", type: "info" },
              customOnClick: {
                key: "action",
                params: {
                  apiKey: "UpdateProgramStatus",
                  apiParams: {}
                },
                formatParams: (rows, record, filters, callback) => {
                  if (!rows) return;
                  if ($$.isArray(rows) && !rows.length) return;
                  // const content = `您确定要批量关闭这${
                  //   $$.isArray(rows) ? rows.length : ""
                  //   }条课件？`;
                  const content = '你确定要关闭选中的课件吗？'
                  let ids = [];
                  rows.forEach(e => {
                    if (e['rowKey']) {
                      ids.push(e['rowKey']);
                    }
                  });
                  WizModal.confirm({
                    title: '注意', content,
                    onOk: () => {
                      callback && callback({
                        idList: ids,
                        status: 2
                      })
                    },
                    onCancel() {
                    }
                  });
                  return null
                }
              },
              recordChangeParams: ({ record, rows }) => {
                let disabled = 0;
                if (rows && rows instanceof Array && rows.length>0){
                  rows.forEach(item => {
                    let {status} =item;
                    if (status !=null && status===2){
                      disabled=1;
                    }
                  })
                }else {
                  disabled = 1;
                }
                return { disabled: disabled }
              }
            },
            {
              key: 'export',
              custom: true,
              params: { icon: 'export', children: '导出', type: 'export'},
              customOnClick: {
                key: 'action',
                params: {
                  apiKey: "export",
                  apiParams: {}
                },
                formatParams: (rows, record, filters, callback) => {
                  return { ...filters }
                }
              }
            }
          ]
        },
        modalFormProps: {},
        dataTableProps: {
          rowKey: "id",
          selectType: "checkbox",
          isScroll: true,
          loading: false,
          // expandedRowRender: (record) => {
          //   return (
          //     <>
          //       <WizRow>
          //         <WizTypography.Paragraph strong>课程受众：</WizTypography.Paragraph>
          //       </WizRow>
          //       <WizSurveyAudience surveyAudienceTitle={"适用范围"} labelWidth={4} style={{ width: '90%' }}  data={record['authData'] || {}} />
          //     </>
          //   )
          // }
        },
        rowOperateSort: ['look','update', 'releaseOrClose', 'advancedSet','QRCode','evaluationManagement','learningRecord'],
        rowOperateView: [
          {
            key: 'look',//课程查看
            custom: true,
            params: { children: '查看'},
            customOnClick: {
              key: 'jumpPage',
              params: {
                key: 'push',
                pathname: pathname+'/programDetailShow'
              }
            }
          },
          {
            key: "update",
            custom: true,
            params: { children: "编辑"},
            customOnClick: {
              key: "jumpPage",
              params: {
                key: "push",
                pathname: pathname+"/programDetailUpd"
              }
            }
          },
          {
            key: "releaseOrClose",
            custom: true,
            params: { children: "发布"},
            textFormat: {
              recordKey: 'status',
              dirt: { 2: '发布', 1: '关闭', 0: "发布" }
            },
            customOnClick: {
              key: "action",
              params: {
                apiKey: "UpdateProgramStatus",
                apiParams: {}
              },
              formatParams: (rows, record, filters, callback) => {
                const content = `您确定要${
                  record['status'] === 1 ? "关闭" : "发布"
                  }该课程吗？`;
                WizModal.confirm({
                  title: '注意', content,
                  onOk: () => {
                    callback && callback({
                      status: record['status'] === 1 ? 2 : 1,
                      idList: [record['id']]
                    })
                  },
                  onCancel() {
                  }
                });
                return null
              }
            }
          },
          {
            key: 'advancedSet',
            custom: true,
            params: {children: '高级设置'},
            customOnClick: {
              key: 'modal',
              params: {
                modalParams: {
                  title: '高级设置',
                  bordered: true,
                  footer: null,
                  destroyOnClose: true,
                  diy: (e) => {
                    return <>
                      <HighSet data={{record: e.record,bizType: 0}}
                              changeModal={e.changeModal}
                      />
                    </>
                  },
                  width: 950
                },
              }
            },
            recordChangeParams: ({record, rows}) => {
              let disabled = false
              if (record && record['status'] === 2) {
                disabled = true
              }
              return {disabled}
            }
          },
          {
            key: "QRCode",
            custom: true,
            params: { children: "二维码" },
            customOnClick: {
              key: 'modal',
              params: {
                modalParams: {
                  title: '课程二维码',
                  footer: null,
                  destroyOnClose: true,
                  diy: (e) => {
                    return <>
                      <h2 align="center">{e.record.name}</h2>
                      <div align='center' style={{ paddingBottom: 20 }}>
                        <QRCode
                          style={{ margin: 20 }}
                          id="qrCode"
                          value={constants.env.sys_get_app_link(`sgmlms://sgmlms/programDetail/${e.record.id}`)}
                          fgColor="#000000" // 二维码的颜色
                        />
                        <br />
                        <a style={{ borderRadius: 3, borderWidth: 1, borderStyle: 'solid', borderColor: '#6faff8', padding: 8 }} id='down_link' onClick={this._downQrCode}>下载二维码</a>
                      </div>
                    </>
                  }
                }
              }
            },
            recordChangeParams: ({ record, rows }) => {
              let disabled = true
              if (record && record['status'] === 1) {
                disabled = false
              }
              return { disabled }
            }
          },
          {
            key: "evaluationManagement",
            custom: true,
            params: { children: "评价管理"},
            customOnClick: {
              key: "jumpPage",
              params: {
                key: "push",
                pathname: pathname+"/programEvaluation"
              }
            }
          },
          {
            key: "learningRecord",
            custom: true,
            params: { children: "学习记录"},
            customOnClick: {
              key: "jumpPage",
              params: {
                key: "push",
                pathname: pathname+"/learningRecord"
              }
            }
          },
        ],
        commonOperate: {
        },
        showAuth: {
          title: '适用范围',
          dataIndex: 'authData'
        }
      }
    }
  }
};

const apis = {
  list: {
    path: `${componentName}/getListByPage`,
    payload: {
      key: `${componentName}@listByPage`,
      apiParams: { pageNum: 1, pageSize: 10 }
    }
  }
  ,
  add: {
    path: `${componentName}/add`,
    payload: {
      key: `${componentName}@add`,
      apiParams: {}
    }
  },
  update: {
    path: `${componentName}/update`,
    payload: {
      key: `${componentName}@update`,
      apiParams: {}
    }
  },
  delete: {
    path: `${componentName}/delete`,
    payload: {
      key: `${componentName}@delete`,
      apiParams: {}
    }
  },
  UpdateProgramStatus: {
    path: `${componentName}/UpdateProgramStatus`,
    payload: {
      key: `${componentName}@UpdateProgramStatus`,
      apiParams: {}
    }
  },
  export: {
    path: `${componentName}/export`,
    payload: {
      key: `${componentName}@export`,
      apiParams: {}
    }
  }

}


let reduxTemplateCofig = (args) => {
  return {
    apis,
    componentName,
    initApiKeys: ['list'],
    needLoading: true,
    ...args
  }
};

export { reduxTemplateCofig, templateConfig };
